var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.questoes, function (questao, idx) {
    return _c('v-row', {
      key: questao.id,
      staticClass: "mb-6"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      class: {
        'erro-pergunta': _vm.exibirErros && questao.obrigatoria && (questao.resposta === null || questao.resposta === '' || questao.resposta === undefined)
      }
    }, [_vm._v(" " + _vm._s(questao.pergunta) + " "), questao.obrigatoria ? _c('span', [_vm._v("*")]) : _vm._e()]), questao.tipo === _vm.tipoPergunta.NOTA1A5 ? _c('v-btn-toggle', {
      staticClass: "mt-2",
      class: {
        'no-pointer': _vm.disabled
      },
      attrs: {
        "dense": ""
      },
      on: {
        "change": function ($event) {
          !_vm.disabled && _vm.emitUpdate(idx, questao.resposta);
        }
      },
      model: {
        value: questao.resposta,
        callback: function ($$v) {
          _vm.$set(questao, "resposta", $$v);
        },
        expression: "questao.resposta"
      }
    }, _vm._l(5, function (item) {
      return _c('v-btn', {
        key: item,
        attrs: {
          "value": item,
          "color": Number(questao.resposta) === item ? 'primary' : ''
        }
      }, [_vm._v(" " + _vm._s(item) + " ")]);
    }), 1) : questao.tipo === _vm.tipoPergunta.ABERTA ? _c('v-textarea', {
      attrs: {
        "solo": "",
        "hide-details": "",
        "rows": "2",
        "outlined": "",
        "maxlength": "500",
        "disabled": _vm.disabled,
        "error": _vm.exibirErros && questao.obrigatoria && (questao.resposta === null || questao.resposta === '')
      },
      on: {
        "input": function ($event) {
          return _vm.emitUpdate(idx, questao.resposta);
        }
      },
      model: {
        value: questao.resposta,
        callback: function ($$v) {
          _vm.$set(questao, "resposta", $$v);
        },
        expression: "questao.resposta"
      }
    }) : _vm._e(), _vm.exibirErros && questao.obrigatoria && (questao.resposta === null || questao.resposta === '' || questao.resposta === undefined) ? _c('div', {
      staticClass: "campo-obrigatorio"
    }, [_vm._v(" Campo Obrigatório ")]) : _vm._e()], 1)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }